import React, { useState } from 'react';
import { Flex } from '@chakra-ui/react';
import {
  FormFieldKeywords,
  FormFieldStringInputArray
} from '@publishing-engine/domain/types/article';
import { TagInputUpdateModal } from './TagInputUpdateModal';
import { TagInputDisplay } from './TagInputDisplay';
import { TagInputEmptyState } from './TagInputEmptyState';
import { FieldHeader } from '../common/FieldHeader';
import { TagDiffModal } from './TagDiffModal';
import { IAvailableWorkflowActions } from '@publishing-engine/domain/models';
import { EntryPoint } from 'src/utils/types';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';

// TODO co-locate with other form field types.
// TODO specify union of all known tag input component types?
export type FormFieldTagInput = Omit<
  FormFieldKeywords | FormFieldStringInputArray,
  'component'
> & {
  component: string;
};

type IProps = {
  formFieldDefinition: FormFieldTagInput;
  value: string[];
  previousValue?: string[];
  availableActions: IAvailableWorkflowActions;
  onChange?: (value: string[]) => void;
  entryPoint: EntryPoint;
  isUpdateRequired?: boolean;
};

export const GenericTagInputField: React.FC<IProps> = ({
  formFieldDefinition,
  value,
  previousValue,
  onChange,
  availableActions,
  entryPoint,
  isUpdateRequired
}) => {
  const { checkFormFieldValueIsUpdated } = useSubmissionFields(entryPoint);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [showDiffModal, setShowDiffModal] = useState<boolean>(false);
  const openDiffModal = () => setShowDiffModal(true);
  const closeDiffModal = () => setShowDiffModal(false);

  const isEditable = !!onChange;

  const editCallback = isEditable
    ? () => {
        setIsEditing(true);
      }
    : undefined;

  const isUpdated = checkFormFieldValueIsUpdated(formFieldDefinition.name);

  return (
    <Flex flexDirection={'column'} gap={2}>
      {/* TODO: why do we need isEditable here? */}
      {isEditing && isEditable && (
        <TagInputUpdateModal
          isOpen={isEditing}
          formField={formFieldDefinition}
          onClose={() => setIsEditing(false)}
          value={value}
          onSubmit={value => {
            setIsEditing(false);
            const fieldValue =
              'keywords' in value
                ? value.keywords
                : Object.values(value)[0] ?? [];

            onChange(fieldValue);
          }}
        />
      )}

      {isUpdated && showDiffModal ? (
        <TagDiffModal
          config={formFieldDefinition}
          value={value}
          previousValue={previousValue || []}
          onClose={closeDiffModal}
        />
      ) : null}

      <FieldHeader
        {...formFieldDefinition}
        label={formFieldDefinition.params.labels.main}
        isUpdated={isUpdated}
        editCallback={editCallback}
        onShowDiffModal={openDiffModal}
        availableActions={availableActions}
        entryPoint={entryPoint}
        isUpdateRequired={isUpdateRequired}
      />

      {value ? (
        <TagInputDisplay value={value} />
      ) : (
        <TagInputEmptyState editCallback={editCallback} />
      )}
    </Flex>
  );
};
